<div class="container-fluid">
    <div class="row">
        
 
<div class="col-md-5">
  
   
        
          <div class="user-information">
            <ul class="user-info">
              <!--
              <li class="user-item">
                <h4><fa-icon style="color: #2D2F44;" [icon]="faFlag"></fa-icon>&nbsp; &nbsp;{{ user.paye }}</h4>
                <hr />
              </li>
              <li class="user-item">
                <h4><fa-icon style="color: #2D2F44;" [icon]="faMapMarker"></fa-icon>&nbsp; &nbsp;{{ user.ville }},{{user.rue}} : {{ user.codePostal }}</h4>
                <hr />
              </li>
              -->
              <li class="user-item">
                <p><fa-icon style="color: #2D2F44;" [icon]="faUniversity"></fa-icon>&nbsp; &nbsp;{{ nomInstitut }} </p>
                <hr />
              </li>
              <li class="user-item">
                <p><fa-icon style="color: #2D2F44;" [icon]="faCalendar"></fa-icon>&nbsp; &nbsp;{{ user.dateNaissance }}</p>
                <hr />
              </li>
              <li class="user-item">
                <p><fa-icon style="color: #2D2F44;" [icon]="faEnvelope"></fa-icon>&nbsp; &nbsp;{{ user.email }}</p>
                <hr />
              </li>
              
              <li class="user-item">
                <h4><fa-icon style="color: #2D2F44;" [icon]="faInfoCircle"></fa-icon>&nbsp; &nbsp;About</h4>
                <textarea style="height: 132px !important; width: 97% ; font-size: medium" value="{{ user.bio }}"></textarea>
                <br />
              </li>
            </ul>
          </div>

          <div  style="height: 100%;"  >
            <div class="user-information">
              <ul class="user-info">
                <li class="user-item">
                  <h4><fa-icon style="color: #2D2F44;" [icon]="faBrain"></fa-icon>&nbsp; &nbsp;Work Field</h4>
                  <div class="skills" >
                    <h6 >{{ user.skills[0] }}</h6>
                    
                  </div>
                  <div class="skills" >
                    
                    <h6>{{ user.skills[1] }}</h6>
                    
                  </div>
                  <div class="skills" >
                    
                    <h6>{{ user.skills[2] }}</h6>
                    
                  </div>
                  <div class="skills" >
                    
                    <h6>{{ user.skills[3] }}</h6>
                    
                  </div>
                  <div class="skills" >
                    
                    <h6>{{ user.skills[4] }}</h6>
                  </div>
                  <hr />
                </li>
                
                  <small>UY : {{ date }} - {{ nextYears }}</small>
              </ul>
            </div>
            <img src="../../assets/images/profile-icon.png" alt="" />
          </div>
        
       
       
    
</div>







<div class="col-md-7">
<style>
    .btn-group {
      width: 100%;
    }
    
</style>

<div class="pub-input" (click)="openCreateModal()">
    <div class="input-container">
        <div class="logo">
            <img src="http://localhost:9091/User/{{user.profileImage}}" alt="logo">
        </div>
        <textarea class="pub-textarea" placeholder="What's on your mind {{user.nom}}?" rows="1"></textarea>
    </div>
    
</div>

<div class="pub-display">
    <div class="pub" *ngFor="let pub of pubs">
        <div class="pub-header">
           
            <div class="user-logo">
                <img [src]="pub.userLogo" alt="logo">
            </div>

            <div class="user-infodis">
                <p class="username">{{pub.clubName}}</p>
                <!--<p class="pub-time">{{pub.pubTime}}</p>-->
            </div>
        
            <div class="pub-options">
                <span class="ellipsis" (click)="togglePubOptions(pub)">&#8942;</span>
                <div *ngIf="pub.showOptions" class="pub-options-dropdown show-dropdown">
                    <button (click)="openUpdateModal(pub)">Update</button>
                    <button (click)="deletePub(pub)">Delete</button>
                </div>
            </div>
              
        </div>
        <div class="pub-content">
            <p>{{pub.content}}</p>
            <img *ngIf="pub.imageUrl" [src]="pub.imageUrl" alt="photo">
            <video *ngIf="pub.videoUrl" [src]="pub.videoUrl" class="pub-video" controls></video>
        </div>
        <div class="pub-actions">
            <button class="left-action" (click)="handleLike(pub)">
                {{pub.liked ? "Unlike" : "Like"}}{{pub.likesCount > 0 ? " (" + pub.likesCount + ")" : ""}}
            </button>
            <button>Comment</button>
            <button class="right-action" (click)="sharePub(pub)">
                Share{{pub.sharesCount > 0 ? " (" + pub.sharesCount + ")" : ""}}
            </button>
        </div>
        <div class="pub-comment">
            <div class="comment-logo">
                <img src="http://localhost:9091/User/{{user.profileImage}}" alt="logo">
            </div>
            <textarea
                class="comment-textarea"
                placeholder="Write a comment..."
                rows="1"
                [(ngModel)]="userComment"
            ></textarea>
            <button (click)="submitComment(pub)" class="commenter">comment</button>
        </div>
        <div *ngFor="let comment of pub.comments | slice:0:displayedCommentsCount">
            <div class="comment">
              <div class="comment-logo">
                <img [src]="pub.userLogo" alt="logo">
              </div>
              <div *ngIf="!comment.editing" class="comment-text">{{comment.text}}</div>
              <textarea
            *ngIf="comment.editing"
           class="comment-textarea"
               placeholder="Edit your comment..."
          rows="1"
            [(ngModel)]="comment.text"
        (keydown.enter)="saveEditedComment(comment, pub, pub.comments.indexOf(comment), $event)"></textarea>
            
              <div class="comment-options">
                <span class="ellipsis" (click)="toggleOptions(comment)">&#8942;</span>
                <div *ngIf="comment.showOptions" class="options">
                  <button (click)="editComment(comment)">Edit</button>
                  <button (click)="deleteComment(pub, comment)">Delete</button>
                </div>
              </div>
            </div>
          </div>
        <div class="more">
            <button *ngIf="pub.comments.length > displayedCommentsCount" (click)="showMoreComments()" style="color: green;">View more</button>
            <button *ngIf="displayedCommentsCount > 2" (click)="hideMoreComments()" style="color: red;">Hide more</button>
        </div>
    </div>
</div>
<br>
<br>

<div class="modal custom-modal-position" id="myModal">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="createpubModalLabel">Create pub</h5>
                <button type="button" class="btn-close-white" data-dismiss="modal" aria-label="Close" style="border-radius: 15px;" (click)="closeModel()">
                    <span>&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <textarea class="form-control" placeholder="What's on your mind?"            rows="3" [(ngModel)]="content"></textarea>
                <img *ngIf="uploadedImageUrl" [src]="uploadedImageUrl" alt="Uploaded Image Preview" class="uploaded-image-preview"/>
                <video *ngIf="uploadedVideoUrl" [src]="uploadedVideoUrl" class="uploaded-video-preview" controls></video>
                <div class="btn-group" role="group" style="padding-top: 10px;">
                    <button type="button" class="btn" style="background: #2D2F44; color: #79D1EF;" >Event</button>
                    <input type="file" #fileInput (change)="onFileSelected($event)" style="display: none;" accept="image/*,video/*" />
                    <button type="button" class="btn" style="background: #2D2F44;color: #79D1EF;" (click)="openFileInput(fileInput)">Photo</button>
                    <button type="button" class="btn" style="background: #2D2F44;color: #79D1EF;" (click)="openFileInput(fileInput)">Video</button>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary" style="width: 100%;background: #2D2F44;color: #79D1EF;" (click)="publishPub()">Publish</button>
            </div>
        </div>
    </div>
</div>
</div>
</div>
</div>

